export const PERSONAL_CATEGORIES = [
  'Personal',
  'Grandmother',
  'Medical',
  'Temple / Pooja Items'
];

export const isPersonalCategory = (category) => {
  if (!category) return false;
  const normalized = category.trim().toLowerCase();
  return (
    normalized === 'personal' ||
    normalized === 'grandmother' ||
    normalized === 'medical' ||
    normalized === 'temple / pooja items' ||
    (normalized.startsWith('temple') && normalized.includes('pooja'))
  );
};
